function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.91 19.032c.502.023.957-.302 1.112-.825l1.907-6.434.655-2.214.264 2.17 1.123 9.23c.072.59.52 1.032 1.057 1.041h.019c.528 0 .98-.422 1.07-1l1.427-9.244c.193.374.552.61.942.61h6.428c.6 0 1.086-.54 1.086-1.205s-.486-1.204-1.086-1.204h-5.776l-1.171-2.441c-.216-.455-.663-.71-1.131-.626-.457.083-.819.478-.898.985l-.576 3.735-.19 1.226-.147-1.21-.923-7.584c-.067-.556-.473-.985-.976-1.037-.511-.051-.974.29-1.13.824l-2.387 8.054-.287.966-.147-.947-.538-3.493c-.08-.519-.454-.92-.925-.99-.468-.08-.926.205-1.13.68l-1.219 2.886H1.086c-.6 0-1.086.54-1.086 1.203 0 .666.486 1.205 1.086 1.205h2.972c.421 0 .805-.27.982-.693l.044-.1.838 5.435c.084.544.492.956.989.997z"
});

var SvgProject = function SvgProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#c4c4c4",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/project.aa32b250.svg";
export { ForwardRef as ReactComponent };